// extracted by mini-css-extract-plugin
export var infoItem = "_r7-2";
export var title = "_r7-0";
export var value = "_r7-1";